import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { Button } from '@/components/ui/Button/button';
import openModal from '@/modals/utils/openModal';
import lockDailyWidget from '@/public/assets/image/daily-bonuses/lock-daily-widget.webp';

const DailyBonusGuestOverlay = () => {
  const t = useTranslations('daily-bonus');
  return (
    <div className="absolute p-4 md:pt-4 inset-0 z-10 flex h-full flex-col items-center justify-center text-center">
      <div className="flex items-center justify-center shrink-0 max-md:mt-2">
        <Image src={lockDailyWidget} alt="Lock" className="size-18 md:size-18.75" />
      </div>
      <p className="font-semibold text-white text-base leading-[120%] mb-1 md:text-[0.75rem] md:leading-4 mt-4 md:mt-2.25">{t('sign-up-to-unlock-daily-bonuses')}</p>
      <p className="text-[0.75rem] text-white leading-4 font-medium md:text-[0.625rem]">
        {t('earn-up-to')}
        {' '}
        <span className="font-semibold text-[1.125rem] leading-7 text-transparent bg-clip-text bg-main-front-gradient md:text-base md:leading-[120%]">75 SC</span>
        {' '}
        {t('every-day')}
      </p>
      <Button variant="primary" size="lg" className="w-full mt-auto py-3 md:py-1.5" onClick={() => openModal('register')}>
        {t('sign-up-and-claim')}
      </Button>
    </div>
  );
};
export default DailyBonusGuestOverlay;
